export default "../media/TF7-overlay.3e957450dbd37050053febdf995da0cd.svg";